import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RoleplayApiService } from '../../service/roleplay.service';
import { RoleplayService } from '../../service/roleplay/roleplay.service';

@Component({
    selector: 'app-doctor-profile',
    templateUrl: './doctor-profile.component.html',
    styleUrl: './doctor-profile.component.scss',
    standalone: false
})
export class DoctorProfileComponent {
  doctorlist: any;
  constructor( private router: Router, private roleplayApiService:RoleplayApiService, private roleplayService: RoleplayService) { }
  public autoMaticProfileCount: number = 0;
  public manualProfileCount: number = 0;
  business_unit_code: string = sessionStorage.getItem('businessUnitCode');

  ngOnInit(): void {
    this.roleplayApiService.getDoctorProfileList(this.business_unit_code).subscribe(res => {
      res.forEach(profile => {
        profile.avatar_url = this.roleplayService.getDoctorProfileImageUrl(profile.avatar_file_name)
      });
      this.doctorlist = res;
      this.autoMaticProfileCount =  res.filter(item => item.profile_type === 'Automatic').length;
      this.manualProfileCount =  res.filter(item => item.profile_type !== 'Automatic').length;
    });
  }
  createprofile(){
    this.router.navigate(['/app-create-profile'], { skipLocationChange: true });
  }

  onEditDoctorProfile(id) {
    this.router.navigate(['/app-create-profile', id], { skipLocationChange: true });
  }

  backbutton() {
    this.router.navigate(['/roleplay/training-dashboard'], { skipLocationChange: true });
  }
}